import { render } from "./NewSubModal.vue?vue&type=template&id=7fb3a50e&scoped=true"
import script from "./NewSubModal.vue?vue&type=script&lang=js"
export * from "./NewSubModal.vue?vue&type=script&lang=js"

import "./NewSubModal.vue?vue&type=style&index=0&id=7fb3a50e&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb3a50e"]])

export default __exports__